import type { Matter } from "@/shared/cache";
import type { SearchableField } from "@/shared/utils/smartSearch";

export function matterNumber(matter: Matter): string | null {
	return matter.matter?.trim() || null;
}

export function matterLookupText(matter: Matter): string {
	return matterNumber(matter) ?? matter.matter_id;
}

export function matterDisplayLabel(matter: Matter): string {
	const number = matterNumber(matter);
	const description = matter.description.trim();
	const client = matter.client.trim();
	return number
		? `${number} | ${description} - ${client}`
		: `${description} - ${client}`;
}

export function matterSearchValue(matter: Matter): string {
	return [matterLookupText(matter), matter.description.trim()]
		.filter(Boolean)
		.join(" ");
}

export const matterSearchFields: ((matter: Matter) => SearchableField)[] = [
	(matter) => ({ value: matterLookupText(matter), weight: 1.5 }),
	(matter) => ({ value: matter.client, weight: 1.2 }),
	(matter) => ({ value: matter.description, weight: 1.0 }),
];
